export default function informationBanners() {
	const containers = document.querySelectorAll('[data-information-banner]');
	let autoOpened = false;

	containers.forEach((banner) => {
		const dialog = banner.querySelector('[data-information-banner-dialog]');

		if (!dialog) {
			return;
		}

		const openButtons = banner.querySelectorAll('[data-information-banner-open]');
		const dismiss = banner.querySelector('[data-information-banner-dismiss]');
		const acknowledge = dialog.querySelector('[data-information-banner-acknowledge]');

		const showDialog = () => {
			if (typeof dialog.showModal === 'function' && !dialog.open) {
				banner.classList.add('information-banner--popup-open');
				dialog.showModal();
			} else if (typeof dialog.showModal !== 'function') {
				banner.classList.remove('information-banner--popup-open');
			}
		};

		openButtons.forEach((button) => button.addEventListener('click', showDialog));
		dismiss?.addEventListener('click', () => {
			const cookieName = banner.dataset.dismissalCookie;

			if (cookieName) {
				document.cookie = `${ cookieName }=1; max-age=31536000; path=/; SameSite=Lax`;
			}

			banner.remove();
		});
		acknowledge?.addEventListener('click', () => {
			const cookieName = dialog.dataset.acknowledgementCookie;

			if (cookieName) {
				document.cookie = `${ cookieName }=1; max-age=31536000; path=/; SameSite=Lax`;
			}
		});
		dialog.addEventListener('click', (event) => {
			if (event.target === dialog) {
				dialog.close();
			}
		});
		dialog.addEventListener('close', () => {
			banner.classList.remove('information-banner--popup-open');
		});

		if (!autoOpened && dialog.hasAttribute('data-auto-open')) {
			autoOpened = true;
			showDialog();
		}
	});
}
